<script setup>
</script>
<template>
  <div class="text-center mt-10">
    <img src = "../assets/img/checkmark.svg" alt="Checkmark" class="w-[100px] sm:w-[180px] m-auto"/>
    <p class="mt-4 mb-10">Thanks for completing the post-test and survey.</p>
  </div>
</template>
